import { useEffect, useState } from "react";
import { AuthTokenRetrieve, LoginButton } from "../Utility/AuthTokenRetrieve";
import { apiFetch } from "../Utility/api";
import "../Food/RecipeList.css";
import "./FoodDiary.css";
import { defaultDailyContextForm, fetchDailyContext } from "./FoodDiaryShared";

const FoodDiaryDailyContext = () => {
  const [shouldShow, setShouldShow] = useState();
  const [entries, setEntries] = useState([]);
  const [form, setForm] = useState(defaultDailyContextForm());
  const [statusMessage, setStatusMessage] = useState("");
  const { shouldShow: shouldShowGoogle } = AuthTokenRetrieve();

  useEffect(() => {
    setShouldShow(shouldShowGoogle);
  }, [shouldShowGoogle]);

  useEffect(() => {
    if (!shouldShow) {
      return;
    }
    fetchDailyContext().then((data) => setEntries(data || []));
  }, [shouldShow]);

  const refreshContext = () => {
    fetchDailyContext().then((data) => setEntries(data || []));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((currentValue) => ({ ...currentValue, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    apiFetch("/food/diary/daily-context", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    })
      .then((response) => response.json())
      .then(() => {
        setStatusMessage("Daily context saved.");
        setForm(defaultDailyContextForm());
        refreshContext();
      });
  };

  const loadForEdit = (entry) => {
    const [month, day, year] = entry.contextDate.split("/");
    setForm({
      contextDate: `${year}-${month}-${day}`,
      sleepHours: entry.sleepHours ?? "",
      stressLevel: entry.stressLevel ?? "",
      exerciseMinutes: entry.exerciseMinutes ?? "",
      caffeineServings: entry.caffeineServings ?? "",
      alcoholServings: entry.alcoholServings ?? "",
      notes: entry.notes || "",
    });
    setStatusMessage("");
  };

  const deleteEntry = (entryId) => {
    apiFetch(`/food/diary/daily-context/${entryId}`, {
      method: "DELETE",
    })
      .then((response) => response.json())
      .then(() => {
        setStatusMessage("Daily context deleted.");
        refreshContext();
      });
  };

  if (!shouldShow) {
    return (
      <div className="searchBarDiv formViewWrapper FoodDiaryLogin">
        <h2>Food diary</h2>
        <p>Sign in to track daily context.</p>
        <LoginButton setShouldShow={setShouldShow}></LoginButton>
      </div>
    );
  }

  return (
    <div className="FoodDiaryPage">
      <div className="FoodDiaryGrid">
        <div className="searchBarDiv formViewWrapper FoodDiaryPanel FoodDiarySinglePanel">
          <h2 className="FoodDiaryTitle">Daily context</h2>
          <p className="FoodDiarySubtitle">Log confounders like sleep, stress, caffeine, alcohol, and exercise.</p>
          {statusMessage ? <p className="FoodDiaryStatus">{statusMessage}</p> : null}
          <form onSubmit={handleSubmit}>
            <div className="FoodDiaryTwoColumn">
              <div className="inputDiv">
                <label>Date</label>
                <input type="date" className="inputBox addInput" name="contextDate" value={form.contextDate} onChange={handleChange} />
              </div>
              <div className="inputDiv">
                <label>Sleep hours</label>
                <input className="inputBox addInput" name="sleepHours" value={form.sleepHours} onChange={handleChange} />
              </div>
            </div>
            <div className="FoodDiaryTwoColumn">
              <div className="inputDiv">
                <label>Stress (1-10)</label>
                <input className="inputBox addInput" name="stressLevel" value={form.stressLevel} onChange={handleChange} />
              </div>
              <div className="inputDiv">
                <label>Exercise minutes</label>
                <input className="inputBox addInput" name="exerciseMinutes" value={form.exerciseMinutes} onChange={handleChange} />
              </div>
            </div>
            <div className="FoodDiaryTwoColumn">
              <div className="inputDiv">
                <label>Caffeine servings</label>
                <input className="inputBox addInput" name="caffeineServings" value={form.caffeineServings} onChange={handleChange} />
              </div>
              <div className="inputDiv">
                <label>Alcohol servings</label>
                <input className="inputBox addInput" name="alcoholServings" value={form.alcoholServings} onChange={handleChange} />
              </div>
            </div>
            <div className="inputDiv">
              <label>Notes</label>
              <textarea className="inputBox textAreaAdd FoodDiaryTextarea" name="notes" value={form.notes} onChange={handleChange} />
            </div>
            <button type="submit" className="summaryButton">Save Context</button>
          </form>
        </div>

        <div className="shoppingListDiv FoodDiaryPanel">
          <h2 className="FoodDiaryTitle">Recent context entries</h2>
          {entries.length ? entries.map((entry) => (
            <div className="FoodDiaryHistoryCard" key={entry.id}>
              <div className="FoodDiaryMealItemHeader">
                <strong>{entry.contextDate}</strong>
                <span>Stress {entry.stressLevel ?? "-"}</span>
              </div>
              <div className="FoodDiaryHistoryMeta">
                <span>Sleep {entry.sleepHours ?? "-"}h</span>
                <span>Exercise {entry.exerciseMinutes ?? "-"}m</span>
                <span>Caffeine {entry.caffeineServings ?? "-"}</span>
                <span>Alcohol {entry.alcoholServings ?? "-"}</span>
              </div>
              {entry.notes ? <p className="FoodDiaryMealNotes">{entry.notes}</p> : null}
              <div className="FoodDiaryActionRow">
                <button className="summaryButton" onClick={() => loadForEdit(entry)}>Load</button>
                <button className="summaryButton" onClick={() => deleteEntry(entry.id)}>Delete</button>
              </div>
            </div>
          )) : <p>No daily context logged yet.</p>}
        </div>
      </div>
    </div>
  );
};

export default FoodDiaryDailyContext;
